import React from 'react';
import * as cr from "./_cr";
import * as cs from "./_ca";
import * as hf from "./_hf";
import * as hfDTM from "./_hfDTM";
import * as ht from "./_ht";

import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as GridC from "./_cccGridC";
import * as TextC from "./_ccbTextC";

import { a } from "./_csAbt";
import * as ls from "./_csLcl";

import * as ica from "src/ica";

let $dtm = hfDTM.getTdy();
//let $dtm = '';
//let $stgz = { hdys: [], dmds: [] } as ht.dz;

export const N = (pz: {
  abtType: ht.s,
  boxStlz: ht.dz,
  cz: {
    dtmz: {
      crt: ht.s,
      stt?: ht.s,
      end?: ht.s,
      hdys?: ht.ls, // holliday
      dmds?: ht.ls, // dimmed
    },
/*
    grtStgzAsync?: (dtm: ht.s) => ({
      hdys: ht.ls, // holliday
      dmds: ht.ls, // dimmed
    }),
*/
    onPrs: ( _date: ht.s ) => void,
  }

}) => {

  const _udtThis = ls.udtThis();

  const _udtDtm = (dtm: ht.s) => {
//hf.l(`_ccmCdrC 42: here`);
    $dtm = dtm;
//    if (pz.cz.grtStgzAsync) $stgz = await pz.cz.grtStgzAsync(dtm);
//hf.l(`_ccmCdrC 45: ${$stgz}`);
    _udtThis();
  };

  React.useEffect(() => {
//hf.l(`_ccmCdrC 50: ${pz.cz.dtmz?.crt}`);
    //hf.l(`_ccmCdrC 55: ${$dtm}, ${pz.cz.dtmz.crt}`);
    if (pz.cz.dtmz.crt) {
      //hf.l(`_ccmCdrC 57: ${$dtm}, ${pz.cz.dtmz.crt}`);
      _udtDtm(hfDTM.cvtFdm(pz.cz.dtmz.crt));
    }
//hf.l(`_ccmCdrC 52: ${$dtm}`);
  }, [
    pz.cz.dtmz.crt
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.cdrAbtz?.[_abtType] ? ica.cdrAbtz?.[_abtType]() : {} as ht.dz;

    const _hdrCs = [] as ht.ls;

    _hdrCs.push({
      boxStlz: a('mb/0'),
      cellCs: [
        {
          boxStlz: a('fd/ccc'),
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              atrIconCz: {
                iconPtyz: a('icn/angle-double-left ics/4')
              },
              pslPtyz: {
                onPress: () => {
//                  $dtm = hfDTM.addYear($dtm, -1);
//                  _frcUdt();
                  _udtDtm(hfDTM.addYear($dtm, -1));
                }
              }
            })
          ]
        },
        {
          boxStlz: a('fd/ccc'),
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              atrIconCz: {
                iconPtyz: a('icn/angle-left ics/4')
              },
              pslPtyz: {
                onPress: () => {
//                  $dtm = hfDTM.addMth($dtm, -1);
//                  _frcUdt();
                  _udtDtm(hfDTM.addMth($dtm, -1));
                }
              }
            })
          ]
        },
        {
          boxStlz: a('dw/20 f/n fd/ccc'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              textz: {
                pfx: hfDTM.f($dtm, 'YYYY-MM'),
                stlz: a('tb ts/l'),
              }
            })
          ]
        },
        {
          boxStlz: a('fd/ccc'),
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              atrIconCz: {
                iconPtyz: a('icn/angle-right ics/4')
              },
              pslPtyz: {
                onPress: () => {
//                  $dtm = hfDTM.addMth($dtm, 1);
//                  _frcUdt();
                  _udtDtm(hfDTM.addMth($dtm, 1));
                }
              }
            })
          ]
        },
        {
          boxStlz: a('fd/ccc'),
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              backgroundColor: 'sc/rd1',
              atrIconCz: {
                iconPtyz: a('icn/angle-double-right ics/4')
              },
              pslPtyz: {
                onPress: () => {
//                  $dtm = hfDTM.addYear($dtm, 1);
//                  _frcUdt();
                  _udtDtm(hfDTM.addYear($dtm, 1));
                }
              }
            })
          ]
        },
      ]
    });

    const _bdyCs = [] as ht.ls;

    _bdyCs.push({
      boxStlz: _abtz.bdyCz.dowCz.boxStlz,
      cellCs: ['日', '月', '火', '水', '木', '金', '土'].map( ( _dow: ht.s, _nIdx: ht.n ) => {
        return {
          oClds: [
            cr.c(TextC.N, {
              key: _nIdx,
              boxStlz: 
                _dow == '日' ?
                  _abtz.bdyCz.dowCz.textCz.boxStlz['日']
                : _dow == '土' ?
                  _abtz.bdyCz.dowCz.textCz.boxStlz['土']
                : _abtz.bdyCz.dowCz.textCz.boxStlz['他'],
              textz: {
                pfx: _dow,
              }
            })
          ]
        }
      })
    });

    let _cellCs = [] as ht.ls;
    const _stt = pz.cz.dtmz.stt ?? '0000-00-00 00:00:00';
    const _end = pz.cz.dtmz.end ?? '9999-12-31 23:59:59';

    hfDTM.cvtCdrDates($dtm).map( ( _dtm: ht.s, _nIdx: ht.n ) => {
      if ( _nIdx > 0 && _nIdx % 7 == 0 ) {
        _bdyCs.push({
          boxStlz: _abtz.bdyCz.dtmCz.boxStlz,
          cellCs: _cellCs
        });
        _cellCs = [];
      }
      _cellCs.push({
//        boxStlz: a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc'),
        boxStlz: a('dh/f dw/f'),
        oClds: [
          cr.c(BtnC.N, {
            key: _nIdx,
            pslPtyz: 
            _dtm >= _stt && _dtm <= _end && !hf.i(_dtm, pz.cz.dtmz.dmds ?? []) ?
//            _dtm >= _stt && _dtm <= _end ?
            {
              style: a('dh/f dw/f'),
              onPress: 
                () => {
                  pz.cz.onPrs(_dtm);
                }
            }
            : null,
            boxStlz: a('dh/f dw/f'),
            lblCz: {
              boxStlz: 
                _dtm < _stt || _dtm > _end ?
                  _abtz.bdyCz.dtmCz.btnCz.lblCz.boxStlz['外']
                : hf.i(_dtm, pz.cz.dtmz.dmds ?? []) ?
                  _abtz.bdyCz.dtmCz.btnCz.lblCz.boxStlz['外']
                : hf.i(_dtm, pz.cz.dtmz.hdys ?? []) ?
                  _abtz.bdyCz.dtmCz.btnCz.lblCz.boxStlz['日']
                : _nIdx % 7 == 0 ?
                  _abtz.bdyCz.dtmCz.btnCz.lblCz.boxStlz['日']
                : _nIdx % 7 == 6 ?
                  _abtz.bdyCz.dtmCz.btnCz.lblCz.boxStlz['土']
                : _abtz.bdyCz.dtmCz.btnCz.lblCz.boxStlz['他']
                ,
              textz: {
                pfx: hfDTM.cvtDay(_dtm),
                stlz: 
                  hfDTM.f(_dtm, 'YYYY-MM') == hfDTM.f($dtm, 'YYYY-MM') ?
                    _abtz.bdyCz.dtmCz.btnCz.lblCz.textz.stlz['同']
                  : _abtz.bdyCz.dtmCz.btnCz.lblCz.textz.stlz['違']
              },
            }
          })
        ]
      }
      )
    });

  _bdyCs.push({
    boxStlz: _abtz.bdyCz.dtmCz.boxStlz,
    cellCs: _cellCs
  }); // 最終行

  return (
    cr.c(BoxC.N, {
      key: 'Cdr.root',
      boxStlz: {
        //ba('dh/f dw/f'),
        ... _abtz.boxStlz,
        ... pz.boxStlz,
      },
      oClds: [
        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
//          abtType: 'none',
          boxStlz: _abtz.hdrCz.boxStlz,
          lineCs: _hdrCs,
        }),
        cr.c(GridC.N, {
          key: -20,
          abtType: 'nolineCmnz',
//          abtType: 'none',
          boxStlz: _abtz.bdyCz.boxStlz,
          lineCs: _bdyCs,
        })
      ]
    })
  )

};
